import { withProps } from '../../../libs/react-utils';
import Field from './Field';
import TextArea from './TextArea';

export default withProps({ Input: TextArea }, Field);
